import React, { ElementType, ReactNode } from 'react';

import { AppBar, Toolbar } from '@mui/material';
import classNames from 'classnames';

import classes from './HeaderBar.module.scss';
import { SOLUTION_TYPE, SolutionType } from '../../../constants/user-info/solutionType';

type HeaderBarProps = {
  children: ReactNode;
  toolbarComponent?: ElementType;
  className?: string;
  /**
   * Fix padding added by angular container
   */
  inAngularContainer?: boolean;
  /** set background color based on solution */
  solution?: SolutionType | null;
};

const HeaderBar = ({
  children,
  toolbarComponent = 'nav',
  className,
  inAngularContainer = false,
  solution,
}: HeaderBarProps) => {
  return (
    <AppBar
      className={classNames(classes.header, className, {
        [classes.inAngularContainer]: inAngularContainer,
        [classes.scanIq]: solution === SOLUTION_TYPE.SCAN_IQ,
        [classes.challenge]: solution === SOLUTION_TYPE.CHALLENGE,
      })}
    >
      <Toolbar component={toolbarComponent}>{children}</Toolbar>
    </AppBar>
  );
};

export { HeaderBar };
